(() => {
  const LOCAL_VALUE = '12oz Local';

  function cleanLocalVariants(root = document) {
    root.querySelectorAll('select').forEach((select) => {
      let changed = false;
      [...select.options].forEach((option) => {
        const text = option.textContent.trim();
        const isLocal = option.value === LOCAL_VALUE || text.includes(LOCAL_VALUE);
        if (isLocal) {
          if (option.selected) changed = true;
          option.remove();
        } else if (text.includes(' — Sold out')) {
          option.textContent = option.textContent.replace(' — Sold out', ' - Sold out');
        }
      });
      if (changed && select.options.length) {
        select.selectedIndex = 0;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    root.querySelectorAll('input[type="radio"][value="12oz Local"]').forEach((input) => {
      const label = input.id ? root.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      label?.remove();
      input.remove();
    });

    root.querySelectorAll('[data-dtcc-resurrection-variant] option').forEach((option) => {
      if (option.textContent.includes(LOCAL_VALUE)) option.remove();
    });
  }

  let queued = false;
  const queueClean = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      cleanLocalVariants();
    });
  };

  document.addEventListener('DOMContentLoaded', () => cleanLocalVariants());
  new MutationObserver(queueClean).observe(document.documentElement, { childList: true, subtree: true });
})();
